import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDashboardinline = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 18 18",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.15,
		d: "M5.813 7.313H3.75a1.5 1.5 0 0 1-1.5-1.5V3.75a1.5 1.5 0 0 1 1.5-1.5h2.063a1.5 1.5 0 0 1 1.5 1.5v2.063a1.5 1.5 0 0 1-1.5 1.5m8.437 0h-2.063a1.5 1.5 0 0 1-1.5-1.5V3.75a1.5 1.5 0 0 1 1.5-1.5h2.063a1.5 1.5 0 0 1 1.5 1.5v2.063a1.5 1.5 0 0 1-1.5 1.5M5.813 15.75H3.75a1.5 1.5 0 0 1-1.5-1.5v-2.063a1.5 1.5 0 0 1 1.5-1.5h2.063a1.5 1.5 0 0 1 1.5 1.5v2.063a1.5 1.5 0 0 1-1.5 1.5m8.437 0h-2.063a1.5 1.5 0 0 1-1.5-1.5v-2.063a1.5 1.5 0 0 1 1.5-1.5h2.063a1.5 1.5 0 0 1 1.5 1.5v2.063a1.5 1.5 0 0 1-1.5 1.5",
		clipRule: "evenodd"
	})
});
export default SvgDashboardinline;
